import { render, staticRenderFns } from "./Page3.vue?vue&type=template&id=41e29e50&scoped=true&"
import script from "./Page3.vue?vue&type=script&lang=js&"
export * from "./Page3.vue?vue&type=script&lang=js&"
import style0 from "./Page3.vue?vue&type=style&index=0&id=41e29e50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e29e50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\src\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41e29e50')) {
      api.createRecord('41e29e50', component.options)
    } else {
      api.reload('41e29e50', component.options)
    }
    module.hot.accept("./Page3.vue?vue&type=template&id=41e29e50&scoped=true&", function () {
      api.rerender('41e29e50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "BuildABox/components/Page3.vue"
export default component.exports